import Http from "./http";

export const getGroupProductFeatureAPI = (data, options) => {
    return Http.post("admin/group/getGroupProductFeature", data, options);
};
